import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=c399f002&scoped=true&"
import script from "./DashboardHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=c399f002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c399f002",
  null
  
)

export default component.exports